import { httpRequest } from "../../utils/HttpRequest";
import {
    IAccountFields,
    IAccountDetail,
    IAccountAdjustApproval,
    IAccountAdjustSubmit,
    IAccountOne,
    IAccountSearch,
    IAccountAdjustFields,
    IAccountAdjustSearch,
    IAccountAdjustDetail,
    IAccountTransferFields,
    IAccountTransferDetail,
    IAccountTransferSearch,
    IAccountWriteoffFields,
    IAccountWriteoffDetail,
    IAccountWriteoffSearch,
    IAccountRechargeFields,
    IAccountRechargeDetail,
    IAccountRechargeSearch,
    IAccountLogSearch,
    IAccountLogDetail,
    ICustomerAccountSummary,
    IAccountSummary,
    ISupplierAccountSummary,
    IFMSInitAccountForm,

} from "./AccountTypes";
import { IPage, IRet } from "../../types/FmsTypes";
import { IMdCustomerExport, IMdCustomerSearch } from "../base/customer/customerService";
import { IMdSupplierSearch } from "../base/supplier/supplierService";
import { Key } from "react";
import { CreditFlagEnum } from "../../types/FmsEnums";
import { LONG_REQUEST_TIMEOUT } from "@/utils/constants";


export const creditFlagDs = () => {
    return [{
        label: '记账',
        value: CreditFlagEnum.CREDIT.valueOf()
    }, {
        label: '现结',
        value: CreditFlagEnum.NON_CREDIT.valueOf()
    }]
}

class AccountShopService {
    //
    async customerSummaryPage(searchVo: IMdCustomerSearch) {
        const apiUrl = "/accountShop/summary/customer/page";
        return await httpRequest
            .post<IPage<ICustomerAccountSummary>>(apiUrl, searchVo);
    }
    async customerSummaryExport(searchVo: IMdCustomerExport) {
        const apiUrl = "/accountShop/summary/customer/export";
        return await httpRequest
            .postFile(apiUrl, searchVo, {
                timeout: LONG_REQUEST_TIMEOUT
            });
    }
    async customerAccountExport(searchVo: any) {
        const apiUrl = "/accountShop/summary/customer/account/export";
        return await httpRequest
            .postFile(apiUrl, searchVo, {
                timeout: LONG_REQUEST_TIMEOUT
            });
    }
    async supplierSummaryExport(searchVo: IMdCustomerExport) {
        const apiUrl = "/accountShop/summary/supplier/export";
        return await httpRequest
            .postFile(apiUrl, searchVo, {
                timeout: LONG_REQUEST_TIMEOUT
            });
    }
    async supplierAccountExport(searchVo: IMdCustomerExport) {
        const apiUrl = "/accountShop/summary/supplier/account/export";
        return await httpRequest
            .postFile(apiUrl, searchVo, {
                timeout: LONG_REQUEST_TIMEOUT
            });
    }
    async customerSummary(searchVo: IMdCustomerSearch) {
        const apiUrl = "/accountShop/summary/customer";
        return await httpRequest
            .post<IAccountSummary>(apiUrl, searchVo);
    }
    //
    async supplierSummaryPage(searchVo: IMdSupplierSearch) {
        const apiUrl = "/accountShop/summary/supplier/page";
        return await httpRequest
            .post<IPage<ISupplierAccountSummary>>(apiUrl, searchVo);
    }
    //
    async supplierSummary(searchVo: IMdSupplierSearch) {
        const apiUrl = "/accountShop/summary/supplier";
        return await httpRequest
            .post<IAccountSummary>(apiUrl, searchVo);
    }
    //账户查询
    async find(param: IAccountFields) {
        const apiUrl = "/accountShop/find";
        return await httpRequest
            .post<IAccountDetail[]>(apiUrl, param)
    }
}

export const accountShopService = new AccountShopService();
